module.exports = __webpack_public_path__ + "img/place.d784c4a0.svg";